export default __webpack_public_path__ + "static/menu-gindakohighball-min1-3061b1b8465798fd4f7d5979ff56f13f.jpg";